module.exports = "<?xml version=\"1.0\" encoding=\"utf-8\"?>\n<svg version=\"1.1\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 64 64\">\n<path d=\"M64,25v14c0,0.6-0.4,1-1,1H1c-0.6,0-1-0.4-1-1V25c0-0.6,0.4-1,1-1h62C63.6,24,64,24.4,64,25z\"/>\n</svg>\n"


//////////////////
// WEBPACK FOOTER
// ./src/icons/actions/remove.svg
// module id = 1385
// module chunks = 0